module.exports = __webpack_public_path__ + "static/img/half-circle-4.409f4a0a.svg";